export const loadScript = (url: string): Promise<void> => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = url;
		script.async = true;

		script.onload = () => {
			resolve();
		};

		script.onerror = () => {
			reject(new Error('Failed to load script'));
		};

		document.body.appendChild(script);
	});
};
